import { useQuery } from 'react-query';
import request from '../../../helpers/request';

const getAttachmentList = async (infoId) => {
  return await request.get(
    `/Information/attachments/${infoId}`,
    {},
    'При загрузке вложений для информирования произошла ошибка'
  );
};

export const createInfoAttachmentListKey = (infoId) => [
  'infoAttachmentList',
  infoId,
];

const useInfoAttachmentList = (infoId, options) =>
  useQuery(
    createInfoAttachmentListKey(infoId),
    () => getAttachmentList(infoId),
    options
  );

export default useInfoAttachmentList;
